import moment from 'moment';

const shortDateFormat = "DD/MM/YYYY";

const longDateFormat = "DD/MM/YYYY HH:mm:ss";

const yearDateFormat = "YYYY";

const monthYearDateFormat = "MM/YYYY"

const shortDateFormatISO = "YYYY/MM/DD";

export const dateFormatter = {

    toShortDate: (date: Date | string | null): string => {
        if (!date)
            return "";

        return (moment(date)).format(shortDateFormat);
    },

    toISOShortDate: (date: Date | string | null): string => {
        if (!date)
            return "";

        return (moment(date)).format(shortDateFormatISO);
    },

    toLongDate: (date: Date | string | null): string => {
        if (!date)
            return "";

        return (moment(date)).format(longDateFormat);
    },

    toYearDate: (date: Date | string | null | undefined): string => {
        if (!date)
            return "";

        return (moment(date)).format(yearDateFormat);
    },
    
    toMonthAndYearDate : (date: Date | string | null | undefined): string => {
        if (!date)
            return "";

        return (moment(date)).format(monthYearDateFormat);
    },

    /*toISOShortDate: (date: Date | string | null): string => {
        if (!date)
            return "";

        return (moment(date)).format(shortDateFormatISO);
    },

    toISOHyphenShortDate: (date: Date | string | null): string => {
        if (!date)
            return "";

        return (moment(date)).format(shortDateFormatISOHyphen);
    },

    toMediumDate: (date: Date | string | null): string => {
        if (!date)
            return "";

        return (moment(date)).format(mediumDateFormat);
    },

    isOlderAsOfToday: (date: Date | string | null) : boolean => {
        if (!date)
            return false;
            
        return date > (new Date());
    },

    convertDaysToMonths: (days: number | undefined | null) : number => {
        if (!days) return 0;
        
        return Math.ceil(days / 30);
    },

    stringToDate: (dayString: string | Date | undefined | null) : Date | undefined => {
        if (!dayString) return undefined;
        
        return new Date(dayString);
    }*/
};